import { render, staticRenderFns } from "./open-app.vue?vue&type=template&id=7c8525a4&scoped=true&"
import script from "./open-app.vue?vue&type=script&lang=js&"
export * from "./open-app.vue?vue&type=script&lang=js&"
import style0 from "./open-app.vue?vue&type=style&index=0&id=7c8525a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8525a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/sit-app-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c8525a4')) {
      api.createRecord('7c8525a4', component.options)
    } else {
      api.reload('7c8525a4', component.options)
    }
    module.hot.accept("./open-app.vue?vue&type=template&id=7c8525a4&scoped=true&", function () {
      api.rerender('7c8525a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/open-app.vue"
export default component.exports